import {
  Checkbox,
  Flex,
  SimpleGrid,
  Textarea,
  useCheckboxGroup,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { IOption, IQuestionDataMultiSelect } from "../../../types";
import { useAppSelector } from "../../../redux/store";
import update from "immutability-helper";

interface MultiSelectOptionsProps {
  options: IOption[];
  value?: IQuestionDataMultiSelect[];
  onChange?: (value: IQuestionDataMultiSelect[]) => void;
}

const MultiSelectOptions: React.FC<MultiSelectOptionsProps> = ({
  options,
  value,
  onChange,
}) => {
  const theme = useAppSelector((state) => state.theme.theme);

  const [otherComment, setOtherComment] = useState<{ [key: string]: string }>(
    {}
  );

  useEffect(() => {
    const data: { [key: string]: string } = {};

    const commentableValues = value?.filter(
      (elm) => elm.additionalValue.comment
    );

    if (commentableValues) {
      for (let i = 0; i < commentableValues.length; i++) {
        data[commentableValues[i].value] =
          commentableValues[i].additionalValue.comment || "";
      }
    }

    setOtherComment(data);
  }, [value]);

  const [localValue, setLocalValue] = useState(value);

  const { getCheckboxProps, value: checkboxValues } = useCheckboxGroup({
    value: localValue?.map((elm) => elm.value),
    onChange: (v) => {
      const newValue = v.map((elm) => {
        return {
          value: elm.toString(),
          additionalValue: {
            comment: otherComment[elm],
          },
        };
      });
      setLocalValue(newValue);
      onChange && onChange(newValue);
    },
  });

  const onChangeOtherComment = (option: IOption, value: string) => {
    const newOtherComment = update(otherComment, {
      [option.value]: {
        $set: value,
      },
    });

    setOtherComment(newOtherComment);

    const onChangeValue = localValue?.map((elm) => {
      return {
        value: elm.value,
        additionalValue: {
          comment: newOtherComment[elm.value],
        },
      };
    });

    onChange && onChangeValue && onChange(onChangeValue);
  };

  return (
    <SimpleGrid
      columns={{ base: 1 }}
      spacingY={{
        base: options.length > 6 ? "15px" : "21px",
        lg: options.length > 6 ? "15px" : "20px",
      }}
      color={theme.textColor}
      px={{ base: "20px", lg: "20px" }}
      w={{ lg: "100%" }}
    >
      {options.map((option) => (
        <Flex flexDirection="column" gap={2} key={option.value}>
          <Checkbox
            size={{ base: "sm", md: "md" }}
            alignItems="flex-start"
            spacing="15px"
            sx={{
              ".chakra-checkbox__control": {
                marginTop: { base: "2px", lg: "9px" },
              },
            }}
            {...getCheckboxProps({ value: option.value })}
          >
            {option.label}
          </Checkbox>
          {option.isOther && checkboxValues?.includes(option.value) && (
            <Textarea
              size={{ base: "sm", md: "md" }}
              onChange={(e: any) =>
                onChangeOtherComment(option, e.target.value)
              }
              placeholder="Tell us more..."
              value={otherComment[option.value] || ""}
            />
          )}
        </Flex>
      ))}
    </SimpleGrid>
  );
};

export default MultiSelectOptions;
